/** The Settings area's sub-routes owned by INC-0611: help, notifications, exports. */
import { hashOf, type Route } from "../../app/router.ts";
import { h } from "../../app/dom.ts";
import type { ViewContext, ViewFactory, ViewHandle } from "../../app/view.ts";
import { mountExports } from "../exports/index.ts";
import { mountHelp } from "../help/index.ts";
import { mountNotifications } from "../notifications/index.ts";
import { mountNotFound, mountStub } from "../stubs.ts";

/** The Settings landing: the area's own state, plus links to the sections that exist. */
export function mountSettings(ctx: ViewContext): ViewHandle {
  const handle = mountStub(ctx, "settings");
  handle.element
    .querySelector(".view-body")
    ?.append(
      h(
        "nav",
        { attrs: { "aria-label": "Settings sections" } },
        h(
          "ul",
          {},
          h(
            "li",
            {},
            h("a", { attrs: { href: hashOf("settings", "notifications") } }, "Notifications"),
          ),
          h(
            "li",
            {},
            h("a", { attrs: { href: hashOf("settings", "exports") } }, "Exports and reports"),
          ),
          h("li", {}, h("a", { attrs: { href: hashOf("settings", "help") } }, "Help and glossary")),
        ),
      ),
    );
  return handle;
}

/** Resolve a Settings route; an unknown section fails closed. */
export function resolveSettings(route: Route): ViewFactory {
  switch (route.sub) {
    case null:
      return mountSettings;
    case "help":
      return mountHelp;
    case "notifications":
      return (ctx) => mountNotifications(ctx);
    case "exports":
      return (ctx) => mountExports(ctx);
    default:
      return mountNotFound;
  }
}
